var map = {
	"./mainNavigationChevron_icon.svg": 1049,
	"./schedule_icon.svg": 1050,
	"./sports_icon.svg": 1051,
	"./table_icon.svg": 1052,
	"./transfers_icon.svg": 1053,
	"./worldnews_icon.svg": 1054
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1243;


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images ^\.\/.*_icon\.svg$
// module id = 1243
// module chunks = 6